import type { ApiRequestFn } from "../../types/api";
import type { PaymentLog } from "../../types/payment";

const createPaymentLogsApi = (request: ApiRequestFn) => ({
  list: () => request<{ data: PaymentLog[] }>("/me/payment-logs"),
  getRunning: () => request<{ data: PaymentLog | null }>("/me/payment-logs/running"),
  cancel: (paymentLogId: number) =>
    request<{ success: boolean }>("/me/payment-logs/cancel", {
      method: "POST",
      body: JSON.stringify({ paymentLogId }),
    }),
});

export { createPaymentLogsApi };
